import PageTitleComponent from "../../components/PageTitle";
import VatComponent from "../../components/Vat";

export default function VatScreen(){
return <div>
    <PageTitleComponent title="Vat" />
    <VatComponent/>
</div>
}